export function convertImageCoordsToSphericalAngles(data = {}) {
  const { x = 0.5, y = 0.5 } = data;

  return [(x - 0.5) * 360, (y - 0.5) * 180];
}

export function convertSphericalAnglesToRadiants(angles) {
  const [yaw, pitch] = angles.map(angle => (angle * Math.PI) / 180);

  return { yaw, pitch };
}

export function convertImageCoordsToRadiants(data) {
  return convertSphericalAnglesToRadiants(convertImageCoordsToSphericalAngles(data));
}

export function convertRadiantsToSphericalAngle(value) {
  return (value / Math.PI) * 180;
}
